import Image from "next/image";
import Link from "next/link";

import img2 from "../../public/images/banner/bannerhome.png";
import shape1 from "../../public/images/shape/shape-01.png";
import shape2 from "../../public/images/shape/shape-02.png";

import { fetchCourses } from "@/services/courseApi";
import { useUser } from "@/context/UserContext";
import { useEffect, useState } from "react";
import OnlineSchoolForm from "../03-online-school/OnlineSchoolForm";
import ResourceForm from "../03-online-school/ResourcesForm";
import StudentFormSwitcher from "./StudentFormSwitcher";

const MainDemoBanner = () => {
  const [course, setCourse] = useState([]);
  const { user } = useUser();


  const [showForm, setShowForm] = useState("internship");

  useEffect(() => {
    const fetchdata = async () => {
      const data = await fetchCourses();
      setCourse(data.courses);
    };
    fetchdata();
  }, []);

  const handleToggleForm = () => {
    setShowForm((prev) => (prev === "internship" ? "resources" : "internship"));
  };

  const renderForm = () => {
    if (!user) {
      return <ResourceForm />;
    }
    if (user.role === "student") {
      return (
        <div className="mt--50">
          <div style={{ marginBottom: "20px", marginTop: '-100px' }}>
            <StudentFormSwitcher
              handleToggleForm={handleToggleForm}
              showForm={showForm}
            />
          </div>

          <div className="form-wrapper" style={{ position: "relative", minHeight: "400px" }}>
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                opacity: showForm === "internship" ? 1 : 0,
                pointerEvents: showForm === "internship" ? "auto" : "none",
                transition: "opacity 0.3s ease-in-out",
                // marginTop : '-100px'
                zIndex: 50
              }}
            >
              <OnlineSchoolForm />
            </div>
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                opacity: showForm === "resources" ? 1 : 0,
                pointerEvents: showForm === "resources" ? "auto" : "none",
                transition: "opacity 0.3s ease-in-out",
              }}
            >
              <ResourceForm />
            </div>
          </div>
        </div>
      );
    }


    return <ResourceForm />;
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 pb--120 pt--70 space-responsive-xxl">
            <div className="content">
              <div className="inner">
                <div className="rbt-new-badge rbt-new-badge-one">
                  <span className="rbt-new-badge-icon">🏆</span> The Leader in
                  Online Learning
                </div>

                <h1 className="title">
                  Upgrade Your Skills. <br /> Elevate Your Career.
                </h1>
                <p className="description" style={{
                  height: 'auto',
                  overflow: 'visible',
                  whiteSpace: 'normal',
                  display: 'block',
                  lineHeight: '1.6'
                }}>
                  Gain real-world expertise through hands-on training,
                  industry-relevant courses, and guided mentorship. Whether you
                  are just starting out or aiming to grow, we help you build the
                  <strong> skills employers value most.</strong>
                </p>
                <div className="slider-btn">
                  <Link
                    className="rbt-btn btn-gradient hover-icon-reverse"
                    href="/course-list"
                  >
                    <span className="icon-reverse-wrapper">
                      <span className="btn-text">View Course</span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                    </span>
                  </Link>
                </div>
              </div>

              <div className="shape-wrapper" id="scene">
                <Image src={img2} width={1100} height={1300} alt="Hero Image" />
                <div className="hero-bg-shape-1 layer" data-depth="0.4">
                  <Image
                    src={shape1}
                    width={428}
                    height={377}
                    alt="Hero Image Background Shape"
                  />
                </div>
                <div className="hero-bg-shape-2 layer" data-depth="0.4">
                  <Image
                    src={shape2}
                    width={372}
                    height={396}
                    alt="Hero Image Background Shape"
                  />
                </div>
              </div>

              <div style={{ width: "100%" }}>{renderForm()}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainDemoBanner;